import { Box } from '@mui/material';
import { PageTitle } from '../components/Page/PageTitle';
import MFMComparison from '../components/MFMComparison/MFMComparison';
import { useTranslation } from 'react-i18next';
import { ROUTES_NS } from './i18n';

export const MFMComparisonRoute = () => {
    const { t } = useTranslation(ROUTES_NS);

    return (
      <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <PageTitle>{t('mfmComparison')}</PageTitle>
          </Box>
          <MFMComparison />
      </>
    );
};
